import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import BookCardsList from '@/components/ui/book-cards-list/BookCardsList';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { getCurrentYear } from '@/helpers/helpers';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

export interface IFreeBooksProps {
  books: IBookPage;
}

const FreeBooks: FC<IFreeBooksProps> = ({ books }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  const currentPage = books.page;
  const currentYear = getCurrentYear();

  //Seo block
  const SEO_TITLE = `Бесплатные книги - читать онлайн полные версии книг без регистрации`;
  const SEO_DESCRIPTION = `Полностью бесплатная подборка книг. Читать онлайн или скачайте книги в FB2, TXT, PDF, EPUB, DOC бесплатно и без регистрации на сайте Fantasy Worlds`;
  const SEO_CANONICAL = '/free-books';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs firstPageName="Бесплатные книги" />
      <Pagination pagesCount={pagesCount ?? 0} postName={`free-books/`} />
      <SectionTitle name="Бесплатные книги" />
      <BookCardsList books={books.data} />
      <Pagination pagesCount={pagesCount ?? 0} postName={`free-books/`} />
    </Layout>
  );
};

export default FreeBooks;
